const defaultClickEventObj = {
	event: 'widgetUserEvent',
	action: 'clicked',
	widgetName: 'ws-detailed-specs',
	widgetId: 'detailed-specs1',
	widgetState: 'default',
	value: undefined,
	fieldValue: undefined,
	formId: undefined,
	formEventId: undefined
};

export function trackEvent(eventData) {
	if (typeof window.jQuery === 'function') {
		window.jQuery(document).trigger('trackEvent', {
			...defaultClickEventObj,
			...eventData
		});
	}
}

export function toggleSpecCategoryEvent(
	widgetName,
	widgetId,
	isExpanded,
	category
) {
	const eventData = {
		widgetName,
		widgetId,
		element: `${category} accordion`,
		elementCTA: category,
		result: isExpanded ? `${category} collapsed` : `${category} expanded`
	};
	return eventData;
}
